<template lang="html">
	<div :class='`${className} label`'>

		<template v-if='inputType == "date" || inputType == "time"'>
			<div class="v-datepicker">
				<datepicker
					:date='startTime'
					:option='datepicker.option'
					:limit='limit'
				/>
				<div class="reset-datepicker" @click='resetDatepicker'></div>
			</div>
		</template>

		<template v-else>
			<input
				v-if='inputType == "text"'
				type='text'
				:placeholder='placeholder'
				:name="name"
				v-model='inputValue'
				@keyup='identicmethod'
				@focus="clearError"
			>
			<input
				v-else-if='inputType == "tel"'
				type='tel'
				:name="name"
				:placeholder='placeholder'
				v-model='inputValue'
				@focus="clearError"
			>
			<input
				v-else-if='inputType == "email"'
				type='email'
				:name="name"
				:placeholder='placeholder'
				v-model='inputValue'
				@focus="clearError"
			>

			<div
				:class='showPass ? "showPassword show" : "showPassword"'
				v-else-if='inputType == "password"'>
				<input
					type='password'
					:placeholder='placeholder'
					:name="name"
					v-model='inputValue'
					@keyup='identicmethod'
					@focus="clearError"
				>
				<input
					type='text'
					:placeholder='placeholder'
					:name="name"
					v-model='inputValue'
					@keyup='identicmethod'
					@focus="clearError"
				>
				<span class='eye'
				@click="showPass = !showPass"></span>
				<span class="focus-bg"></span>
			</div>

			<div
				v-else-if='inputType == "checkbox"'
				:class='novalide ? "wrapper" : "wrapper error"'>
					<input
						type='checkbox'
						:name='name'
						v-model='inputValue'
						@change='noerror'
					>
			</div>
			<span class="focus-bg"></span>

			<div class="validation-errors">
				<transition name='fade' mode='out-in' v-if="validator">
					<div class="serverError-message">{{ validator }}</div>
				</transition>
				<transition name='fade' mode='out-in'>
					<div v-show='showMessage.required' class="required">{{ textRequired }}</div>
				</transition>
				<transition name='fade' mode='out-in'>
					<div v-show='showMessage.wrongSymbol && !mask.complete' class="wrong-symbol" v-html='textWrongSymbol'></div>
				</transition>
			</div>
		</template>
	</div>
</template>

<script>
const Inputmask = require('inputmask');
const objectMerge = require('object-merge');

module.exports = {
	name: 'input',

	props: {
		// тип інпута: text, mail, tel і т.д.
		type: {
			type: String,
			required: true,
			default: 'text'
		},

		// ключ для поля, в якому лежатиме його значення в результуючому масиві
		name: {
			type: String,
			required: true
		},

		// значення інпута
		value: {
			type: String | Number,
			required: false,
			default: ''
		},

		// не знаю що це таке і нащо воно, просто є в масиві даних
		text: {
			type: String
		},

		// вказує, чи обов'язкове поле для заповнення
		required: {
			type: Boolean,
			required: false,
			default: true
		},

		// текст плейсхолдера
		placeholder: {
			type: String,
			required: true,
			default: ''
		},

		// певні значення для мовних версій
		locals: {
			type: Array,
			required: false,
			default: () => []
		},

		// текст валідатора
		validator: {
			type: String,
			required: true
		},

		// проміжок для дейтпікера
		limit: {
			type: Object | Array,
			required: false
		},

		// для дейтпікера можливість вибрати декілька дат
		multiple: {
			type: Boolean,
			required: false
		},

		// индификатор тождествености емейла или пароля
		identic: {
			type: String
		},

		check: {
			type: String
		}
	},

	components: {
		datepicker: require('vue-datepicker')
	},

	data() {
		return {
			// ширина вікна
			vw: window.innerWidth,

			inputCheck: false,

			// прапорці маски
			mask: {
				complete: false,
			},

			// прапорці для відображення того чи іншого повідомлення
			showMessage: {
				incomplete: false,
				required: false,

				// заборонений символ
				wrongSymbol: '',
			},

			// flag валидации чекбокса
			novalide: true,

			// зв"язка даних із інпутом
			inputValue: '',

			// поля для проверки повтора ввода emeil и пароля
			mailOrigin: '',
			mailIdentic: '',
			passwordOrigin: '',
			passwordIdentic: '',

			showPass: '',
			showPass1: '',

			// власне фінал всієї логіки, виставляється прапорець валідності поля
			valid: false,

			// v-bind для дейтпікера
			startTime: {
				time: this.inputValue
			}

			// datepicker: {
			// 	startTime: {
			// 		time: ''
			// 	},
			// 	endtime: {
			// 		time: ''
			// 	},
			// 	testTime: '',
			// 	multiTime: '',
         //
			// 	option: {
			// 		type: 'day',
			// 		format: 'DD-MM-YYYY',
			// 		placeholder: this.placeholder,
			// 		week: window.YAMASTERS_FRONTEND.datepicker.week,
			// 		month: window.YAMASTERS_FRONTEND.datepicker.month
			// 	}
			// }
		}
	},

	computed: {
		datepicker() {
			let type = '';
			let format = '';

			if(this.type == 'date') {
				type = 'day';
				format = window.YAMASTERS_FRONTEND.datepicker.formats.day;
			};
			if(this.type == 'time') {
				type = 'min';
				format = window.YAMASTERS_FRONTEND.datepicker.formats.time;
			}
			if(this.multiple) {
				type = 'multi-time';
			}

			return {
				option: {
					type,
					format,
					week: window.YAMASTERS_FRONTEND.datepicker.week,
					month: window.YAMASTERS_FRONTEND.datepicker.month,
					placeholder: this.placeholder,
					buttons: {
						ok: window.YAMASTERS_FRONTEND.datepicker.buttons.ok,
						cancel: window.YAMASTERS_FRONTEND.datepicker.buttons.cancel
					},
					overlayOpacity: 0.5,
					dismissible: true,
				}
			}
		},

		inputType() {
			let type = '';

			switch (this.type) {
				case 'text':
				case 'tel':
				case 'password':
				case 'radio':
				case 'checkbox':
				case 'date':
				case 'time':
					type = this.type;
				break;

				default:
					type = 'text';
			}

			return type;
		},

		className() {
			let base = 'v-field';

			if(this.mask.complete) {
				base += ' completed';
			}

			if(this.showMessage.incomplete) {
				base += ' incompleted';
			}

			if(this.showMessage.required) {
				base += ' required';
			}

			return base;
		},

		textRequired() {
			return this.validator ? this.validator : window.YAMASTERS_FRONTEND.validator.messages.required;
		},

		textWrongSymbol() {
			return window.YAMASTERS_FRONTEND.validator.messages.wrongSymbol.replace(/#SYMBOL#/g, this.showMessage.wrongSymbol)
		}
	},

	watch: {
		['startTime.time']() {
			this.inputValue = this.startTime.time;

			if(this.inputValue) {
				this.mask.complete = true;
				this.showMessage.incomplete = false;
				this.showMessage.required = false;
			}
			else {
				this.mask.complete = false;
			}
		}
	},

	methods: {
		clearError(){
			// console.log(this);
			this.$el.classList.remove('serverError');
		},
		// если нажат чекбокс, убтраем ошибку валидации
		noerror() {
			// console.log(this.$el.children[0].children[0].checked);
			if(this.$el.children[0].children[0].checked){
				this.novalide = true;
			}
		},
		identicmethod(){
			if(this.type == 'email'){
				if(this.identic == 'origin'){
					mailOrigin = this.inputValue;
				}
				if(this.identic == 'ident'){
					mailIdentic = this.inputValue;
					this.showMessage.incomplete = true;
					try {
						if(mailOrigin == mailIdentic){
							this.showMessage.incomplete = false;
						}
					}catch(e){
						console.log(e);
					}
				}
			}

			if(this.type == 'password'){
				// console.log(this.type);
				if(this.identic == 'origin'){
					// console.log(this.identic);
					passwordOrigin = this.inputValue;
				}
				if(this.identic == 'ident'){
					passwordIdentic = this.inputValue;
					this.showMessage.incomplete = true;
					// console.log(this.identic);
					try {
						if(passwordOrigin == passwordIdentic){
							this.showMessage.incomplete = false;
						}
					}catch(e){
						console.log(e);
					}
				}
			}
			if(this.type == 'text'){
				// console.log(this.type);
				if(this.identic == 'origin'){
					// console.log(this.identic);
					passwordOrigin = this.inputValue;
				}
				if(this.identic == 'ident'){
					passwordIdentic = this.inputValue;
					this.showMessage.incomplete = true;
					// console.log(this.identic);
					try {
						if(passwordOrigin == passwordIdentic){
							this.showMessage.incomplete = false;
						}
					}catch(e){
						console.log(e);
					}
				}
			}
		},

		resetDatepicker() {
			this.startTime.time = '';
		},

		mapSettings(obj) {
			// console.log(obj);
			const callbacks = {

				// поле заповнене вірно і до кінця
				oncomplete: () => {
					// console.log('oncomplete');
					this.mask.complete = true;
					this.showMessage.incomplete = false;
				},

				// поле не заповнене до кінця
				onincomplete: (e) => {
					// console.log('onincomplete');
					this.mask.complete = false;
					this.showMessage.wrongSymbol = '';

					if(e.target.value.length) {
						this.showMessage.incomplete = true;
					}
					else {
						this.showMessage.incomplete = false;
					}
				},

				// обробка введеного символу
				onKeyValidation: (key, result) => {
					// console.log(key, result);
					// console.log('onKeyValidation');
					this.showMessage.incomplete = false;
					this.showMessage.required = false;

					if(!result) {
						this.showMessage.wrongSymbol = String.fromCharCode(key);
					}
					else {
						this.showMessage.wrongSymbol = '';
					}
				},

				// поле очищене повністю
				oncleared: e => {
					// console.log('oncleared');
					// console.log(e);
				},

				// була натиснута кнопка
				onKeyDown: (e, buffer, caretPos, opts) => {
					switch (e.keyCode) {
						case 8:
						// backspace
						this.showMessage.wrongSymbol = '';
						this.mask.complete = e.target.inputmask.isComplete() ? true : false;
						break;
						default:

					}
				}
			}

			for (var cb in callbacks) {
				if (callbacks.hasOwnProperty(cb)) {
					obj[cb] = callbacks[cb];
				}
			}

			return obj;
		},

		initPhoneMask(mask) {
			return a = new Inputmask(this.mapSettings({
				mask,
				inputmode: 'tel',
				greedy: false,
				definitions: {
					'#': '',
					'^': {
						validator: "[0-9\\s]",
						cardinality: 1,
						casing: "lower"
					}
				}
			}));
		},

		initMailMask(mask) {
			return new Inputmask(this.mapSettings({
				mask,
				inputmode: 'email',
				greedy: false,
				definitions: {
					'*': {
						validator: "[0-9A-Za-z_-]",
						cardinality: 1,
						casing: "lower"
					},
					'@': {
						validator: '@',
						cardinality: 1,
						casing: 'lower'
					},
					'd': {
						validator: '.',
						cardinality: 1,
						casing: 'lower'
					}
				}
			}));
		},

		validate(refName) {
			// перевірим, чи являється поле обов'язковим для заповнення

			// обов'язкове поле
			if(this.type == "checkbox"){
				// console.log(this.required);
				if(this.required){
					// console.log(this.$el.children[0].children[0].checked);
					if(this.$el.children[0].children[0].checked){
						this.valid = true;
						this.novalide = true;
					}else{
						this.valid = false;
						this.novalide = false;
					}
				}else{
					this.valid = true;
					this.novalide = true;
				}
			}else if(this.required) {
				if(!this.mask.complete) {
					this.showMessage.required = true;
					this.showMessage.incomplete = true;
					this.showMessage.wrongSymbol = '';
					this.valid = false;

					this.$emit('IS_VALID', {
						[refName]: false
					});
				}
				else {
					this.valid = true;

					this.$emit('IS_VALID', {
						[refName]: true
					});

					this.$emit('ADD_PAYLOAD', {
						[this.name]: this.inputValue
					})
				}
			}

			// не обов'язкове поле
			else {
				if(!this.showMessage.incomplete) {
					this.valid = true;

					this.$emit('IS_VALID', {
						[refName]: true
					});

					this.$emit('ADD_PAYLOAD', {
						[this.name]: this.inputValue
					})
				}
				else {
					this.valid = false;

					this.$emit('IS_VALID', {
						[refName]: false
					});
				}
			}
		}
	},

	mounted() {
		let setChecked = () => {
			if(this.type == "checkbox"){
				// console.log(this.check);
				if(this.check == "checked"){
					setTimeout(() => {
						this.$el.parentElement.click();
					}, 100);
				}
			}
		}
		setChecked();

		window.addEventListener('resize', () => {
	this.vw = window.innerWidth;
});

switch (this.type) {

	// запускаєм маску для телефона
	case 'tel':
	this.im = this.initPhoneMask(window.YAMASTERS_FRONTEND.validator.mask.tel.default)
	break;

	// запускаєм маску для імейла
	case 'email':
	this.im = this.initMailMask(window.YAMASTERS_FRONTEND.validator.mask.email)
	break;

	/*
	Для інпутів, які не опрацьовуються маскою, потрібно виставити потрібні
	прапорці вручну, навісивши на них відповідні обробники подій.
	*/
	default:
	this.$el.querySelector('input').addEventListener('input', e => {
		// console.log(e);
		this.showMessage.incomplete = false;
		this.showMessage.required = false;

		if(e.target.value) {
			this.mask.complete = true;
		}
		else {
			this.mask.complete = false;
		}
	})
}

// якщо маска була налаштована, то запустим її (не всі інпути її потребують)
this.im ? this.im.mask(this.$el.querySelector('input')) : false;

this.$el.querySelector('input').addEventListener('input', e => {

	// зв"язка значення інпута із логікою
	// this.inputValue = e.target.value;

	/*
	На смартфоні і планшеті чогось не спрацьовує метод onKeyValidation,
	тому не можна  перевірити символ на валідність (по крайній мірі, простою логікою).
	Але можна прибрати повідомлення про те, що це поле обов'язкове до заповнення,
	після того, як в інпут почнуть вводити дані.
	*/
	if(this.vw < 1024 && this.im) {
		this.showMessage.incomplete = false;
		this.showMessage.required = false;

		if(e.target.inputmask.isComplete()) {
			this.showMessage.incomplete = false;
		}
		else {
			this.showMessage.incomplete = true;
		}
	}
});


let field = this.$el.querySelector('input');
field.value = this.value;
this.inputValue = this.value;

if(this.im) {
	// console.log(field.inputmask);
	// console.log(`Type: ${this.type}. Completed: ${field.inputmask.isComplete()}`);
	if(field.inputmask.isComplete()) {
		this.showMessage.incomplete = false;
		this.showMessage.required = false;
		this.mask.complete = true;
	}
}
else {
	// console.log(`Type: ${this.type}. Completed: ${field.value ? true : false}`);

	if(field.value) {
		this.showMessage.incomplete = false;
		this.showMessage.required = false;
		this.mask.complete = true;
	}
}

	}
}
</script>

<style lang="scss">
	@import "wanted";

	.v-field {
		display: block;
		position: relative;
		// color: white;
		margin-bottom: 13px;
		color: #282828;
		clear: both;

		&:after {
			content: '';
			display: flex;
			position: absolute;
			top: -22px;
			right: 5px;
			// bottom: 15px;
			width: 25px;
			align-items: center;
			justify-content: center;
			z-index: 1;
			@include pointer-events(none);
			opacity: 0;
			@include single-transition;
		}

		&.completed  {
			&:after {
				@include fa($fa-check);
				opacity: 1;
				color: green;
			}
		}

		&.incompleted {
			&:after {
				@include fa($fa-times);
				opacity: 1;
				color: red;
			}
		}

		.cov-vue-date {
			width: 100%;
		}

		.showPassword{
			position: relative;
			.eye{
				position: absolute;
				width: 18px;
				height: 14px;
				right: 10px;
				top: calc(50% - 7px);
				cursor: pointer;
				background-image: url(../img/eye.svg);
				background-size: contain;
				background-repeat: no-repeat;
				background-position: center;
			}
			[type="password"]{
				display: block;
			}
			[type="text"]{
				display: none;
			}
			&.show{
				[type="password"]{
					display: none;
				}
				[type="text"]{
					display: block;
				}
			}
		}
		.wrapper {
			position: relative;
			&:before{
				content: '';
				display: flex;
				position: absolute;
				top: calc(50% + 10px);
				left: -6px;
				width: 25px;
				align-items: center;
				justify-content: center;
				z-index: 1;
				pointer-events: none;
				opacity: 0;
				transition: all 300ms ease;
			}
			&.error{
				&:before{
					content: "\F00D";
					font-family: "FontAwesome";
					text-rendering: auto;
					-webkit-font-smoothing: antialiased;
					-moz-osx-font-smoothing: grayscale;
					opacity: 1;
					color: red;
				}
			}
		}
		input {
			font-family: $ProximaNova_regular;
			font-size: rem(15);
			color: #000;
			margin: 0;
			position: relative;
			cursor: pointer;
			color: #282828;
			width: 100%;
			border: 1px solid #b1b1b1;
			padding: 14px 19px 12px 19px;
			border-radius: 10px;
			// margin-bottom: 13px;
			@include placeholder {
				color: #282828;
			}
		}

		input ~ .focus-bg{
			&:before, &:after{
				content: "";
				position: absolute;
				left: 50%;
				top: 50%;
				width: 0;
				height: 0;
				background-color: rgba(#ededed, .15);
				transition: 0.3s;
				z-index: -1;
			}
			&:after{
				left: auto;
				right: 50%;
				top: auto;
				bottom: 50%;
			}
		}

		input:focus ~ .focus-bg{
			&:before{
				transition: 0.3s;
				width: 50%;
				left: 0;
				top: 0;
				height: 100%;
				z-index: 0;
			}
			&:after{
				transition: 0.3s;
				width: 50%;
				height: 100%;
				bottom: 0;
				right: 0;
				z-index: 0;
			}
		}

		.validation-errors {
			position: absolute;
			left: 0;
			right: 0;
			top: 100%;
			height: 15px;
			z-index: 1;
			font-size: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			@include m_up{
				left: auto;
				right: 30px;
				top: 100%;
			};
			.serverError-message{
				display: none;
				white-space: nowrap;
				margin-right: -25px;
			}

			.fade-enter-active, .fade-leave-active {
				@include single-transition;
			}
			.fade-enter, .fade-leave-to {
				opacity: 0;
				@include translateY(5px);
			}
		}
	}
</style>



// WEBPACK FOOTER //
// input.vue?e272d228